import {
    Condition,
    FiveZoneToothNumber,
    FourZoneToothNumber,
    PermanentUpperJawToothNumber,
    PermanentLowerJawToothNumber,
    BabyUpperJawToothNumber,
    BabyLowerJawToothNumber,
    ToothNumber,
    RightToothNumber,
    LeftToothNumber,
} from './types';
import type { TranslationValues } from '@chaika/i18n/types';
import { ToothZone } from '@patient/ui/DentalPage/components/DentalFormula/types';

export type ConditionId = (typeof conditionIds)[keyof typeof conditionIds];

export type ToothCategory = keyof typeof teethParts;

export interface ConditionConfig {
    parentId?: ConditionId;
    label: TranslationValues;
    condition?: Condition;
    shortLabel?: TranslationValues;
}

export const conditions = [
    Condition.Normal,
    Condition.Problem,
    Condition.Treated,
    Condition.Missing,
    Condition.Implant,
    Condition.ImplantProblem,
];

export const fiveZoneTeeth: FiveZoneToothNumber[] = [
    ToothNumber.Tooth14,
    ToothNumber.Tooth15,
    ToothNumber.Tooth16,
    ToothNumber.Tooth17,
    ToothNumber.Tooth18,
    ToothNumber.Tooth24,
    ToothNumber.Tooth25,
    ToothNumber.Tooth26,
    ToothNumber.Tooth27,
    ToothNumber.Tooth28,
    ToothNumber.Tooth34,
    ToothNumber.Tooth35,
    ToothNumber.Tooth36,
    ToothNumber.Tooth37,
    ToothNumber.Tooth38,
    ToothNumber.Tooth44,
    ToothNumber.Tooth45,
    ToothNumber.Tooth46,
    ToothNumber.Tooth47,
    ToothNumber.Tooth48,
    ToothNumber.Tooth54,
    ToothNumber.Tooth55,
    ToothNumber.Tooth64,
    ToothNumber.Tooth65,
    ToothNumber.Tooth74,
    ToothNumber.Tooth75,
    ToothNumber.Tooth84,
    ToothNumber.Tooth85,
];

export const fourZoneTeeth: FourZoneToothNumber[] = [
    ToothNumber.Tooth11,
    ToothNumber.Tooth12,
    ToothNumber.Tooth13,
    ToothNumber.Tooth21,
    ToothNumber.Tooth22,
    ToothNumber.Tooth23,
    ToothNumber.Tooth31,
    ToothNumber.Tooth32,
    ToothNumber.Tooth33,
    ToothNumber.Tooth41,
    ToothNumber.Tooth42,
    ToothNumber.Tooth43,
    ToothNumber.Tooth51,
    ToothNumber.Tooth52,
    ToothNumber.Tooth53,
    ToothNumber.Tooth61,
    ToothNumber.Tooth62,
    ToothNumber.Tooth63,
    ToothNumber.Tooth71,
    ToothNumber.Tooth72,
    ToothNumber.Tooth73,
    ToothNumber.Tooth81,
    ToothNumber.Tooth82,
    ToothNumber.Tooth83,
];

export const permanentTeeth: {
    upperJaw: PermanentUpperJawToothNumber[];
    lowerJaw: PermanentLowerJawToothNumber[];
} = {
    upperJaw: [
        ToothNumber.Tooth18,
        ToothNumber.Tooth17,
        ToothNumber.Tooth16,
        ToothNumber.Tooth15,
        ToothNumber.Tooth14,
        ToothNumber.Tooth13,
        ToothNumber.Tooth12,
        ToothNumber.Tooth11,
        ToothNumber.Tooth21,
        ToothNumber.Tooth22,
        ToothNumber.Tooth23,
        ToothNumber.Tooth24,
        ToothNumber.Tooth25,
        ToothNumber.Tooth26,
        ToothNumber.Tooth27,
        ToothNumber.Tooth28,
    ],
    lowerJaw: [
        ToothNumber.Tooth48,
        ToothNumber.Tooth47,
        ToothNumber.Tooth46,
        ToothNumber.Tooth45,
        ToothNumber.Tooth44,
        ToothNumber.Tooth43,
        ToothNumber.Tooth42,
        ToothNumber.Tooth41,
        ToothNumber.Tooth31,
        ToothNumber.Tooth32,
        ToothNumber.Tooth33,
        ToothNumber.Tooth34,
        ToothNumber.Tooth35,
        ToothNumber.Tooth36,
        ToothNumber.Tooth37,
        ToothNumber.Tooth38,
    ],
};

export const babyTeeth: {
    upperJaw: BabyUpperJawToothNumber[];
    lowerJaw: BabyLowerJawToothNumber[];
} = {
    upperJaw: [
        ToothNumber.Tooth55,
        ToothNumber.Tooth54,
        ToothNumber.Tooth53,
        ToothNumber.Tooth52,
        ToothNumber.Tooth51,
        ToothNumber.Tooth61,
        ToothNumber.Tooth62,
        ToothNumber.Tooth63,
        ToothNumber.Tooth64,
        ToothNumber.Tooth65,
    ],
    lowerJaw: [
        ToothNumber.Tooth85,
        ToothNumber.Tooth84,
        ToothNumber.Tooth83,
        ToothNumber.Tooth82,
        ToothNumber.Tooth81,
        ToothNumber.Tooth71,
        ToothNumber.Tooth72,
        ToothNumber.Tooth73,
        ToothNumber.Tooth74,
        ToothNumber.Tooth75,
    ],
};

export const teethParts = {
    upperLeftJaw: [
        ToothNumber.Tooth18,
        ToothNumber.Tooth17,
        ToothNumber.Tooth16,
        ToothNumber.Tooth15,
        ToothNumber.Tooth14,
        ToothNumber.Tooth13,
        ToothNumber.Tooth12,
        ToothNumber.Tooth11,
        ToothNumber.Tooth55,
        ToothNumber.Tooth54,
        ToothNumber.Tooth53,
        ToothNumber.Tooth52,
        ToothNumber.Tooth51,
    ],
    upperRightJaw: [
        ToothNumber.Tooth21,
        ToothNumber.Tooth22,
        ToothNumber.Tooth23,
        ToothNumber.Tooth24,
        ToothNumber.Tooth25,
        ToothNumber.Tooth26,
        ToothNumber.Tooth27,
        ToothNumber.Tooth28,
        ToothNumber.Tooth61,
        ToothNumber.Tooth62,
        ToothNumber.Tooth63,
        ToothNumber.Tooth64,
        ToothNumber.Tooth65,
    ],
    lowerLeftJaw: [
        ToothNumber.Tooth48,
        ToothNumber.Tooth47,
        ToothNumber.Tooth46,
        ToothNumber.Tooth45,
        ToothNumber.Tooth44,
        ToothNumber.Tooth43,
        ToothNumber.Tooth42,
        ToothNumber.Tooth41,
        ToothNumber.Tooth85,
        ToothNumber.Tooth84,
        ToothNumber.Tooth83,
        ToothNumber.Tooth82,
        ToothNumber.Tooth81,
    ],
    lowerRightJaw: [
        ToothNumber.Tooth31,
        ToothNumber.Tooth32,
        ToothNumber.Tooth33,
        ToothNumber.Tooth34,
        ToothNumber.Tooth35,
        ToothNumber.Tooth36,
        ToothNumber.Tooth37,
        ToothNumber.Tooth38,
        ToothNumber.Tooth71,
        ToothNumber.Tooth72,
        ToothNumber.Tooth73,
        ToothNumber.Tooth74,
        ToothNumber.Tooth75,
    ],
};

export const permanentToothNumbers = [...permanentTeeth.lowerJaw, ...permanentTeeth.upperJaw];
export const babyToothNumbers = [...babyTeeth.lowerJaw, ...babyTeeth.upperJaw];

export const toothNumbers = [...permanentToothNumbers, ...babyToothNumbers];

export const upperToothNumbers = [...permanentTeeth.upperJaw, ...babyTeeth.upperJaw];

export const lowerToothNumbers = [...permanentTeeth.lowerJaw, ...babyTeeth.lowerJaw];

export const mirroredToothMap: Partial<Record<RightToothNumber, LeftToothNumber>> = {
    [ToothNumber.Tooth21]: ToothNumber.Tooth11,
    [ToothNumber.Tooth22]: ToothNumber.Tooth12,
    [ToothNumber.Tooth23]: ToothNumber.Tooth13,
    [ToothNumber.Tooth24]: ToothNumber.Tooth14,
    [ToothNumber.Tooth25]: ToothNumber.Tooth15,
    [ToothNumber.Tooth26]: ToothNumber.Tooth16,
    [ToothNumber.Tooth27]: ToothNumber.Tooth17,
    [ToothNumber.Tooth28]: ToothNumber.Tooth18,
    [ToothNumber.Tooth31]: ToothNumber.Tooth41,
    [ToothNumber.Tooth32]: ToothNumber.Tooth42,
    [ToothNumber.Tooth33]: ToothNumber.Tooth43,
    [ToothNumber.Tooth34]: ToothNumber.Tooth44,
    [ToothNumber.Tooth35]: ToothNumber.Tooth45,
    [ToothNumber.Tooth36]: ToothNumber.Tooth46,
    [ToothNumber.Tooth37]: ToothNumber.Tooth47,
    [ToothNumber.Tooth38]: ToothNumber.Tooth48,
    [ToothNumber.Tooth61]: ToothNumber.Tooth51,
    [ToothNumber.Tooth62]: ToothNumber.Tooth52,
    [ToothNumber.Tooth63]: ToothNumber.Tooth53,
    [ToothNumber.Tooth64]: ToothNumber.Tooth54,
    [ToothNumber.Tooth65]: ToothNumber.Tooth55,
    [ToothNumber.Tooth71]: ToothNumber.Tooth81,
    [ToothNumber.Tooth72]: ToothNumber.Tooth82,
    [ToothNumber.Tooth73]: ToothNumber.Tooth83,
    [ToothNumber.Tooth74]: ToothNumber.Tooth84,
    [ToothNumber.Tooth75]: ToothNumber.Tooth85,
};

export const statePriority = [
    Condition.ImplantProblem,
    Condition.Implant,
    Condition.Missing,
    Condition.Problem,
    Condition.Treated,
    Condition.Normal,
];

export const CROWN = '3589ad74-3b68-4811-a15d-006bee905d82';
export const CROWN__CHIP = 'e705f3a3-035a-488e-82d7-02cec7a8602c';
export const CROWN__CRACK_FRACTURE = '6bc00255-ff0a-459c-b928-ec23603a2739';
export const CROWN__HYPOPLASIA_FLUOROSIS = '8b8c29b1-1f76-473a-9d8b-c2e443a50927';
export const CROWN__COLOR_CHANGE = '1dd1db71-d8d8-458f-90db-3f25bb2a43b6';
export const CROWN__POST_AND_CORE = 'af329047-bc7d-434f-9b55-6044b7ac3232';
export const CROWN__SEALED_FISSURES = 'e3f5714a-12cc-456c-983e-ceef9e8af8ff';
export const CROWN__CROWN = '7cabeb37-7c7c-4963-bd62-5a82bfafcda4';
export const CROWN__MISSING = 'd472320e-ad85-4c0c-be9d-ff038c8365f4';
export const CROWN__DEFECT_FREE_CROWN = 'd0464d9a-6ae8-4556-83a2-1f06a6fed8c3';
export const CROWN__TEMPORARY_CROWN = '56fc7dea-3c22-42fb-9ec1-2c1b999e1733';
export const CROWN__DEFECTIVE_CROWN = '85c0c62a-c71b-457e-870e-28da77b8ba01';
export const CROWN__VENEER = '0cacddc4-8068-4682-8557-9dddcdfa9120';
export const CROWN__DEFECT_FREE_VENEER = 'e9aeeec5-8c26-479a-a220-d353bf0a45e0';
export const CROWN__DEFECTIVE_VENEER = 'a304f32f-7211-4143-9c53-6def7b90962b';
export const CROWN__INLAY_ONLAY = '701864a4-0985-4a5e-8d73-2b616eb60a58';
export const CROWN__DEFECT_FREE_INLAY = '6005e842-5da1-4f3e-a794-53a34c69206c';
export const CROWN__DEFECTIVE_INLAY = 'fcff8a09-bbfc-45e0-8d29-c39619e65fd6';
export const CROWN__CARIES = '5ff50c3a-4a7e-4258-8efc-32f8fd97033e';
export const CROWN__DEFECTIVE_FILLING = '42590928-f085-430a-94b5-77346d076365';
export const CROWN__EROSION = 'a1a00a4c-10dc-4b81-82d9-23eb634a512b';
export const CROWN__WEDGE_DEFECT = 'ed8acc80-ec46-48ab-8d1c-8782d334a820';
export const CROWN__PIGMENTATION = '928e41de-5dff-4a74-972b-330e4e0df143';
export const CROWN__FILLING = '586ab7f7-865b-4caa-b347-f37e5baa9b76';
export const CROWN__BRIDGE = 'bab1117f-a005-4ffa-96b7-a92f36d75b53';
export const CROWN__FILLING_CARIES = '415e1171-ff4f-42d6-a00f-987028dd15ad';
export const CROWN__OVERHANGING_MARGIN = 'af7f15d9-87e3-4db6-b417-e4207208ba0d';

export const CROWN_SURFACE = '49131acf-066c-4d6c-bf45-59ee288cd17c';
export const CROWN_SURFACE__CARIES = '3bc6cd70-8c5b-4302-b9d0-36281a935b5e';
export const CROWN_SURFACE__DEFECTIVE_FILLING = '22d4e5cf-7356-48cc-8a08-9787a7a54a89';
export const CROWN_SURFACE__EROSION = 'ccfac218-d4a8-4865-8ae4-c297b465ff95';
export const CROWN_SURFACE__WEDGE_DEFECT = '5aee2338-fa89-4262-b831-288e4f9bae83';
export const CROWN_SURFACE__PIGMENTATION = 'fa57f58d-011b-4f61-9362-4e06e19a42b5';
export const CROWN_SURFACE__FILLING = '6ff6b32c-9088-4ed2-9943-27f9d857baa2';
export const CROWN_SURFACE__BRIDGE = 'c979ba34-2c06-4873-b94f-df09ff146c9a';
export const CROWN_SURFACE__MISSING = 'cc785d87-1d5b-4bdb-b294-e89d55328898';
export const CROWN_SURFACE__SEALED_FISSURES = 'a770f4af-80f4-41bb-a006-820057d33151';
export const CROWN_SURFACE__CHIP = '7f48942d-7498-4e52-a860-2275c339b212';
export const CROWN_SURFACE__FILLING_CARIES = 'e64d714f-f91d-4b76-ba72-dd3d156fe462';
export const CROWN_SURFACE__OVERHANGING_MARGIN = '73847484-492c-4ff3-8176-b31802330f0b';
export const CROWN__IMPLANT_CROWN = '54582eb9-7f19-4ca1-aab2-7f8eb03f2779';
export const CROWN_SURFACE__DEFECT_FREE_IMPLANT_CROWN = '690d8f03-10a8-49dd-a0a5-79f88c08aff0';
export const CROWN_SURFACE__DEFECTIVE_IMPLANT_CROWN = '16168e13-c800-4eee-a3b0-242660614b56';

export const ROOT = 'a035e005-c151-4415-8cb1-74a42297f381';
export const ROOT__RESORPTION = 'bf452f9d-d047-4276-9fcb-d34027ce165e';
export const ROOT__FRACTURE = '606ef471-4905-49bc-ae67-f840cb387e3d';
export const ROOT__CRACK = '84ee484a-ebfa-440b-ac20-6f3f05aef57b';
export const ROOT__PULPITIS = '1664208d-e158-41cc-9d1e-177caaae26da';
export const ROOT__PERIODONTITIS = 'e5d47619-47b7-4522-9c4c-fddcfc8380a8';
export const ROOT__INLAY_PERIODONTITIS = '8c093e05-3777-4e2c-a6d6-71685c7ff016';
export const ROOT__WIDENED_PERIODONTAL_LIGAMENT_SPACE = 'f687859b-8e04-4aa8-979e-b5943ff94577';
export const ROOT__WITHOUT_PATHOLOGY = '3909774f-0c04-42c6-ba4b-1afb06aabeb7';
export const ROOT__PERI_IMPLANTITIS = '90af2d7d-1124-4c33-82a7-65a731159b20';
export const ROOT__IMPLANT = '7f392a02-cf93-4ecd-bafa-ae56b2ae3acb';
export const ROOT__MISSING = '07649f04-c7a4-470b-897f-946f7e2a4428';
export const ROOT__PERFORATION = 'f6e624ed-07c1-4006-b97b-80e5f9545cd0';
export const ROOT__CANAL_CALCIFICATION = '51526470-d1ab-4fae-a6a4-f6e0f5b1b4b0';
export const ROOT__IMPACTED_ECTOPIC = '5b4dbcdc-49ab-44ff-9fd8-0ccdbdcd2abd';
export const ROOT__IMPACTED_ECTOPIC_WITH_SYMPTOMS = '8be04e22-a7d9-4a0c-b8a1-5977e67e74d9';
export const ROOT__IMPACTED_ECTOPIC_WITHOUT_SYMPTOMS = 'ad027659-732c-4958-8a0e-c2b22d16d875';
export const ROOT__DEVITALIZED = '8b0779af-652d-48ed-82d4-872993b8b177';
export const ROOT__DEVITALIZED_WITH_COMPLICATIONS = 'f9989d47-510e-4cd6-8bed-bfd486b1be1d';
export const ROOT__DEVITALIZED_WITHOUT_COMPLICATIONS = '7c70488d-1393-4e06-9200-915ba8e08a7f';

export const GUM = '1b9e433f-8470-4f2c-9920-c525fea069a1';
export const GUM__GINGIVITIS = '97cbe1ad-38f6-4215-97e8-960a35ec129d';
export const GUM__PERIODONTITIS = '966ba5c1-b026-4312-a897-d1d005dc958f';
export const GUM__DENTAL_CALCULUS = '170bb4d0-d1bd-47dd-9968-3bc0f7a5355b';
export const GUM__RECESSION = '1308712b-f86a-43a7-8e0f-ee00ca77914a';

export const WHOLE_TOOTH = '19812c4f-7f75-4cf7-956d-26f955b6654f';
export const WHOLE_TOOTH__ECTOPIC = 'e2287f3f-080b-488a-9ee0-df0cc0920821';
export const WHOLE_TOOTH__MISSING = 'b6efc388-d623-4f0d-81c0-576d7939d868';
export const WHOLE_TOOTH__IMPACTED = '7262370b-f137-423d-90e2-106f23cc8431';
export const WHOLE_TOOTH__INTACT_TOOTH = 'a81a78de-495e-440f-a844-e107efb8d063';

export const conditionIds = {
    CROWN,
    CROWN__CHIP,
    CROWN__CRACK_FRACTURE,
    CROWN__HYPOPLASIA_FLUOROSIS,
    CROWN__COLOR_CHANGE,
    CROWN__POST_AND_CORE,
    CROWN__SEALED_FISSURES,
    CROWN__CROWN,
    CROWN__MISSING,
    CROWN__DEFECT_FREE_CROWN,
    CROWN__TEMPORARY_CROWN,
    CROWN__DEFECTIVE_CROWN,
    CROWN__VENEER,
    CROWN__DEFECT_FREE_VENEER,
    CROWN__DEFECTIVE_VENEER,
    CROWN__INLAY_ONLAY,
    CROWN__DEFECT_FREE_INLAY,
    CROWN__DEFECTIVE_INLAY,
    CROWN__IMPLANT_CROWN,
    CROWN__CARIES,
    CROWN__DEFECTIVE_FILLING,
    CROWN__EROSION,
    CROWN__WEDGE_DEFECT,
    CROWN__PIGMENTATION,
    CROWN__FILLING,
    CROWN__BRIDGE,
    CROWN__FILLING_CARIES,
    CROWN__OVERHANGING_MARGIN,
    CROWN_SURFACE,
    CROWN_SURFACE__CARIES,
    CROWN_SURFACE__DEFECTIVE_FILLING,
    CROWN_SURFACE__EROSION,
    CROWN_SURFACE__WEDGE_DEFECT,
    CROWN_SURFACE__PIGMENTATION,
    CROWN_SURFACE__FILLING,
    CROWN_SURFACE__BRIDGE,
    CROWN_SURFACE__MISSING,
    CROWN_SURFACE__SEALED_FISSURES,
    CROWN_SURFACE__CHIP,
    CROWN_SURFACE__FILLING_CARIES,
    CROWN_SURFACE__OVERHANGING_MARGIN,
    CROWN_SURFACE__DEFECT_FREE_IMPLANT_CROWN,
    CROWN_SURFACE__DEFECTIVE_IMPLANT_CROWN,
    ROOT,
    ROOT__RESORPTION,
    ROOT__FRACTURE,
    ROOT__CRACK,
    ROOT__PULPITIS,
    ROOT__PERIODONTITIS,
    ROOT__INLAY_PERIODONTITIS,
    ROOT__WIDENED_PERIODONTAL_LIGAMENT_SPACE,
    ROOT__WITHOUT_PATHOLOGY,
    ROOT__PERI_IMPLANTITIS,
    ROOT__IMPLANT,
    ROOT__MISSING,
    ROOT__PERFORATION,
    ROOT__CANAL_CALCIFICATION,
    ROOT__IMPACTED_ECTOPIC,
    ROOT__IMPACTED_ECTOPIC_WITH_SYMPTOMS,
    ROOT__IMPACTED_ECTOPIC_WITHOUT_SYMPTOMS,
    ROOT__DEVITALIZED,
    ROOT__DEVITALIZED_WITH_COMPLICATIONS,
    ROOT__DEVITALIZED_WITHOUT_COMPLICATIONS,
    GUM: GUM,
    GUM__GINGIVITIS,
    GUM__PERIODONTITIS,
    GUM__DENTAL_CALCULUS,
    GUM__RECESSION,
    WHOLE_TOOTH,
    WHOLE_TOOTH__ECTOPIC,
    WHOLE_TOOTH__MISSING,
    WHOLE_TOOTH__IMPACTED,
    WHOLE_TOOTH__INTACT_TOOTH,
} as const;

export const conditionConfigMap = new Map<ConditionId, ConditionConfig>([
    // crown
    [CROWN, { label: 'crownPart' }],
    [CROWN__CHIP, { parentId: CROWN, condition: Condition.Problem, label: 'chip' }],
    [CROWN__MISSING, { parentId: CROWN, condition: Condition.Missing, label: 'missing' }],
    [CROWN__CRACK_FRACTURE, { parentId: CROWN, condition: Condition.Problem, label: 'crackFracture' }],
    [CROWN__HYPOPLASIA_FLUOROSIS, { parentId: CROWN, condition: Condition.Problem, label: 'hypoplasiaFluorosis' }],
    [CROWN__COLOR_CHANGE, { parentId: CROWN, condition: Condition.Warning, label: 'colorChange' }],
    [CROWN__POST_AND_CORE, { parentId: CROWN, condition: Condition.Treated, label: 'postAndCore' }],
    [CROWN__SEALED_FISSURES, { parentId: CROWN, condition: Condition.Treated, label: 'sealedFissures' }],
    [CROWN__CROWN, { parentId: CROWN, label: 'crown' }],
    [
        CROWN__DEFECT_FREE_CROWN,
        { parentId: CROWN, condition: Condition.Treated, label: 'defectFreeCrown', shortLabel: 'healthy' },
    ],
    [
        CROWN__TEMPORARY_CROWN,
        { parentId: CROWN, condition: Condition.Treated, label: 'temporaryCrown', shortLabel: 'temporary' },
    ],
    [
        CROWN__DEFECTIVE_CROWN,
        { parentId: CROWN, condition: Condition.Problem, label: 'defectiveCrown', shortLabel: 'defective' },
    ],
    [CROWN__IMPLANT_CROWN, { parentId: CROWN_SURFACE, label: 'implantCrown' }],
    [CROWN__VENEER, { parentId: CROWN, label: 'veneer' }],
    [
        CROWN__DEFECT_FREE_VENEER,
        { parentId: CROWN, condition: Condition.Treated, label: 'defectFreeVeneer', shortLabel: 'healthy' },
    ],
    [
        CROWN__DEFECTIVE_VENEER,
        { parentId: CROWN, condition: Condition.Problem, label: 'defectiveVeneer', shortLabel: 'defective' },
    ],
    [CROWN__INLAY_ONLAY, { parentId: CROWN, label: 'inlayOnlay' }],
    [
        CROWN__DEFECT_FREE_INLAY,
        { parentId: CROWN, condition: Condition.Treated, label: 'defectFreeInlay', shortLabel: 'healthy' },
    ],
    [
        CROWN__DEFECTIVE_INLAY,
        { parentId: CROWN, condition: Condition.Problem, label: 'defectiveInlay', shortLabel: 'defective' },
    ],
    [CROWN__CARIES, { parentId: CROWN, condition: Condition.Problem, label: 'caries' }],
    [CROWN__DEFECTIVE_FILLING, { parentId: CROWN, condition: Condition.Problem, label: 'defectiveFilling' }],
    [CROWN__EROSION, { parentId: CROWN, condition: Condition.Problem, label: 'erosion' }],
    [CROWN__WEDGE_DEFECT, { parentId: CROWN, condition: Condition.Problem, label: 'wedgeDefect' }],
    [CROWN__PIGMENTATION, { parentId: CROWN, condition: Condition.Warning, label: 'pigmentation' }],
    [CROWN__FILLING, { parentId: CROWN, condition: Condition.Treated, label: 'filling' }],
    [CROWN__BRIDGE, { parentId: CROWN, condition: Condition.Treated, label: 'bridge' }],
    [CROWN__FILLING_CARIES, { parentId: CROWN, condition: Condition.Problem, label: 'fillingCaries' }],
    [CROWN__OVERHANGING_MARGIN, { parentId: CROWN, condition: Condition.Problem, label: 'overhangingMargin' }],
    // surface
    [CROWN_SURFACE, { label: 'surface' }],
    [CROWN_SURFACE__CARIES, { parentId: CROWN_SURFACE, condition: Condition.Problem, label: 'caries' }],
    [
        CROWN_SURFACE__DEFECTIVE_FILLING,
        { parentId: CROWN_SURFACE, condition: Condition.Problem, label: 'defectiveFilling' },
    ],
    [CROWN_SURFACE__EROSION, { parentId: CROWN_SURFACE, condition: Condition.Problem, label: 'erosion' }],
    [CROWN_SURFACE__WEDGE_DEFECT, { parentId: CROWN_SURFACE, condition: Condition.Problem, label: 'wedgeDefect' }],
    [CROWN_SURFACE__PIGMENTATION, { parentId: CROWN_SURFACE, condition: Condition.Warning, label: 'pigmentation' }],
    [CROWN_SURFACE__FILLING, { parentId: CROWN_SURFACE, condition: Condition.Treated, label: 'filling' }],
    [CROWN_SURFACE__BRIDGE, { parentId: CROWN_SURFACE, condition: Condition.Treated, label: 'bridge' }],
    [CROWN_SURFACE__MISSING, { parentId: CROWN_SURFACE, condition: Condition.Missing, label: 'missing' }],
    [
        CROWN_SURFACE__SEALED_FISSURES,
        { parentId: CROWN_SURFACE, condition: Condition.Treated, label: 'sealedFissures' },
    ],
    [CROWN_SURFACE__CHIP, { parentId: CROWN_SURFACE, condition: Condition.Problem, label: 'chip' }],
    [CROWN_SURFACE__FILLING_CARIES, { parentId: CROWN_SURFACE, condition: Condition.Problem, label: 'fillingCaries' }],
    [
        CROWN_SURFACE__OVERHANGING_MARGIN,
        { parentId: CROWN_SURFACE, condition: Condition.Problem, label: 'overhangingMargin' },
    ],
    [
        CROWN_SURFACE__DEFECT_FREE_IMPLANT_CROWN,
        {
            parentId: CROWN_SURFACE,
            condition: Condition.Treated,
            label: 'defectFreeImplantCrown',
            shortLabel: 'healthy',
        },
    ],
    [
        CROWN_SURFACE__DEFECTIVE_IMPLANT_CROWN,
        {
            parentId: CROWN_SURFACE,
            condition: Condition.Problem,
            label: 'defectiveImplantCrown',
            shortLabel: 'defective',
        },
    ],
    // root
    [ROOT, { label: 'root' }],
    [ROOT__RESORPTION, { parentId: ROOT, condition: Condition.Problem, label: 'resorption' }],
    [ROOT__FRACTURE, { parentId: ROOT, condition: Condition.Problem, label: 'fracture' }],
    [ROOT__CRACK, { parentId: ROOT, condition: Condition.Problem, label: 'crack' }],
    [ROOT__PULPITIS, { parentId: ROOT, condition: Condition.Problem, label: 'pulpitis' }],
    [ROOT__PERIODONTITIS, { parentId: ROOT, condition: Condition.Problem, label: 'periodontitis' }],
    [ROOT__INLAY_PERIODONTITIS, { parentId: ROOT, condition: Condition.Problem, label: 'inlayPeriodontitis' }],
    [
        ROOT__WIDENED_PERIODONTAL_LIGAMENT_SPACE,
        { parentId: ROOT, condition: Condition.Warning, label: 'widenedPeriodontalLigamentSpace' },
    ],
    [ROOT__WITHOUT_PATHOLOGY, { parentId: ROOT, condition: Condition.Treated, label: 'withoutPathology' }],
    [ROOT__PERI_IMPLANTITIS, { parentId: ROOT, condition: Condition.ImplantProblem, label: 'periImplantitis' }],
    [ROOT__IMPLANT, { parentId: ROOT, condition: Condition.Implant, label: 'implant' }],
    [ROOT__MISSING, { parentId: ROOT, condition: Condition.Missing, label: 'missing' }],
    [ROOT__PERFORATION, { parentId: ROOT, condition: Condition.Problem, label: 'perforation' }],
    [ROOT__CANAL_CALCIFICATION, { parentId: ROOT, condition: Condition.Warning, label: 'canalCalcification' }],
    [ROOT__IMPACTED_ECTOPIC, { parentId: ROOT, label: 'impactedEctopic' }],
    [
        ROOT__IMPACTED_ECTOPIC_WITH_SYMPTOMS,
        {
            parentId: ROOT,
            condition: Condition.Problem,
            label: 'impactedEctopicWithSymptoms',
            shortLabel: 'withSymptoms',
        },
    ],
    [
        ROOT__IMPACTED_ECTOPIC_WITHOUT_SYMPTOMS,
        {
            parentId: ROOT,
            condition: Condition.Warning,
            label: 'impactedEctopicWithoutSymptoms',
            shortLabel: 'withoutSymptoms',
        },
    ],
    [ROOT__DEVITALIZED, { label: 'devitalized' }],
    [
        ROOT__DEVITALIZED_WITH_COMPLICATIONS,
        {
            parentId: ROOT,
            condition: Condition.Problem,
            label: 'devitalizedWithComplications',
            shortLabel: 'withComplications',
        },
    ],
    [
        ROOT__DEVITALIZED_WITHOUT_COMPLICATIONS,
        {
            parentId: ROOT,
            condition: Condition.Warning,
            label: 'devitalizedWithoutComplications',
            shortLabel: 'withoutComplications',
        },
    ],
    // gum
    [GUM, { label: 'gum' }],
    [GUM__GINGIVITIS, { parentId: GUM, condition: Condition.Problem, label: 'gingivitis' }],
    [GUM__PERIODONTITIS, { parentId: GUM, condition: Condition.Problem, label: 'periodontitisSecond' }],
    [GUM__DENTAL_CALCULUS, { parentId: GUM, condition: Condition.Warning, label: 'dentalCalculus' }],
    [GUM__RECESSION, { parentId: GUM, condition: Condition.Warning, label: 'recession' }],
    // whole tooth
    [WHOLE_TOOTH, { label: 'wholeTooth' }],
    [WHOLE_TOOTH__ECTOPIC, { parentId: WHOLE_TOOTH, condition: Condition.Problem, label: 'ectopic' }],
    [WHOLE_TOOTH__MISSING, { parentId: WHOLE_TOOTH, condition: Condition.Missing, label: 'missing' }],
    [WHOLE_TOOTH__IMPACTED, { parentId: WHOLE_TOOTH, condition: Condition.Problem, label: 'impacted' }],
    [WHOLE_TOOTH__INTACT_TOOTH, { parentId: WHOLE_TOOTH, condition: Condition.Treated, label: 'intactTooth' }],
]);

export const zoneLabels: Record<ToothCategory, Partial<Record<ToothZone, TranslationValues>>> = {
    upperLeftJaw: {
        [ToothZone.One]: 'buccal',
        [ToothZone.Two]: 'mesial',
        [ToothZone.Three]: 'palatal',
        [ToothZone.Four]: 'distal',
        [ToothZone.Five]: 'occlusal',
    },
    upperRightJaw: {
        [ToothZone.One]: 'buccal',
        [ToothZone.Two]: 'distal',
        [ToothZone.Three]: 'palatal',
        [ToothZone.Four]: 'mesial',
        [ToothZone.Five]: 'occlusal',
    },
    lowerLeftJaw: {
        [ToothZone.One]: 'palatal',
        [ToothZone.Two]: 'mesial',
        [ToothZone.Three]: 'buccal',
        [ToothZone.Four]: 'distal',
        [ToothZone.Five]: 'occlusal',
    },
    lowerRightJaw: {
        [ToothZone.One]: 'palatal',
        [ToothZone.Two]: 'distal',
        [ToothZone.Three]: 'buccal',
        [ToothZone.Four]: 'mesial',
        [ToothZone.Five]: 'occlusal',
    },
};

export const legacyDentalQuadrantOrder: string[] = ['5', '6', '1', '2', '4', '3', '8', '7'];
